import { TxpEventTypes, TxpEventTypesV2 } from '../store/schema/TxpOptionState';
import strings from 'owa-strings/owa-options-strings';
import { isFeatureEnabled } from 'owa-feature-flags';
import { IDropdownOption } from 'office-ui-fabric-react/lib/Dropdown';

/**
 * The type encapsulating the different event types
 */
export type TxpEventFlags = keyof TxpEventTypes;

/**
 * The type encapsulating the different event types for V2 options
 */
export type TxpEventFlagsV2 = keyof TxpEventTypesV2;

/**
 * Returns the drop down options for the new TXP settings option
 */
export const settingsOptions: IDropdownOption[] = [
    {
        key: 0,
        text: strings.options_txp_new_dropdownNoneOptionText,
    },
    {
        key: 1,
        text: strings.options_txp_new_dropdownManualOptionText,
    },
    {
        key: 2,
        text: strings.options_txp_new_dropdownAutoOptionText,
    },
];

/**
 * Returns the string for the label of the checkbox fo the txp flag in the UI
 * @param flagName The name of the event flag
 */
export function getLabelForTxpFlag(flagName: TxpEventFlags): string {
    switch (flagName) {
        case 'FlightEventsFromEmailEnabled':
            return strings.options_txp_flights;
        case 'HotelEventsFromEmailEnabled':
            return strings.options_txp_hotelReservations;
        case 'RentalCarEventsFromEmailEnabled':
            return strings.options_txp_carRentals;
        case 'PackageDeliveryEventsFromEmailEnabled':
            return strings.options_txp_packageDelivery;
        case 'DiningEventsFromEmailEnabled':
            return strings.options_txp_diningReservations;
        case 'EntertainmentEventsFromEmailEnabled':
            return strings.options_txp_events;
        case 'InvoiceEventsFromEmailEnabled':
            return strings.options_txp_bills;
        case 'ServiceAppointmentEventsFromEmailEnabled':
            return strings.options_txp_serviceAppointments;
        default:
            return '';
    }
}

/**
 * Checks the feature flags to determine if this event type is enabled
 * @param eventType The event type which should be validated
 */
export function isEventTypeEnabled(eventType: TxpEventFlags | TxpEventFlagsV2) {
    switch (eventType) {
        case 'InvoiceEventsFromEmailEnabled':
        case 'Invoice':
            return isFeatureEnabled('cal-txp-invoice');
        case 'ServiceAppointmentEventsFromEmailEnabled':
        case 'ServiceReservation':
            return isFeatureEnabled('cal-txp-serviceReservation');
    }

    // All other events are enabled by default
    return true;
}

/**
 * Returns the list of all EventFlagTypes in the order they should be displayed in the UI
 */
export const EventsInOptionsPageInOrder: TxpEventFlags[] = [
    'FlightEventsFromEmailEnabled',
    'HotelEventsFromEmailEnabled',
    'RentalCarEventsFromEmailEnabled',
    'PackageDeliveryEventsFromEmailEnabled',
    'DiningEventsFromEmailEnabled',
    'EntertainmentEventsFromEmailEnabled',
    'InvoiceEventsFromEmailEnabled',
    'ServiceAppointmentEventsFromEmailEnabled',
];

/**
 * Returns the list of all EventFlagTypes in the order they should be displayed in the UI
 */
export const EventsInOptionsV2PageInOrder: TxpEventFlagsV2[] = [
    'Invoice',
    'ParcelDelivery',
    'ServiceReservation',
    'FlightReservation',
    'FoodEstablishmentReservation',
    'LodgingReservation',
    'RentalCarReservation',
    'EventReservation',
];

/**
 * Returns the dialog title for the new TXP settings from card UI
 */
export function getDialogTextForTxpFlag(flagName: TxpEventFlagsV2): string {
    switch (flagName) {
        case 'FlightReservation':
            return strings.options_txp_new_flightDialogText;
        case 'LodgingReservation':
            return strings.options_txp_new_hotelDialogText;
        case 'RentalCarReservation':
            return strings.options_txp_new_rentalCarDialogText;
        case 'ParcelDelivery':
            return strings.options_txp_new_packageDeliveryDialogText;
        case 'FoodEstablishmentReservation':
            return strings.options_txp_new_diningDialogText;
        case 'EventReservation':
            return strings.options_txp_new_eventDialogText;
        case 'Invoice':
            return strings.options_txp_new_invoiceDialogText;
        case 'ServiceReservation':
            return strings.options_txp_new_serviceReservationDialogText;
        default:
            return '';
    }
}

/**
 * Returns the dialog text for the new TXP settings from card UI
 */
export function getDialogTitleForTxpFlag(flagName: TxpEventFlagsV2): string {
    switch (flagName) {
        case 'FlightReservation':
            return strings.options_txp_new_flightDialogTitle;
        case 'LodgingReservation':
            return strings.options_txp_new_hotelDialogTitle;
        case 'RentalCarReservation':
            return strings.options_txp_new_rentalCarDialogTitle;
        case 'ParcelDelivery':
            return strings.options_txp_new_packageDeliveryDialogTitle;
        case 'FoodEstablishmentReservation':
            return strings.options_txp_new_diningDialogTitle;
        case 'EventReservation':
            return strings.options_txp_new_eventDialogTitle;
        case 'Invoice':
            return strings.options_txp_new_invoiceDialogTitle;
        case 'ServiceReservation':
            return strings.options_txp_new_serviceReservationDialogTitle;
        default:
            return '';
    }
}
